import styled from '@emotion/styled';

interface ProgressBarProps {
  progress:number;
}

const Progressbar:React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <ProgressBarContainer>
      <ProgressBarFill progress={progress}/>
    </ProgressBarContainer>
  )
};

export default Progressbar;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: #D9D9D9;
  border-radius: 4px;
`;
const ProgressBarFill = styled.div<ProgressBarProps>`
  height: 100%;
  background-color: #111111;
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
  width: ${(props) => props.progress}%;
`;